import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { ModalFormComponent, type ModalFormComponentCtx } from '../../components/modal.form/modal.form.component';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { OrgDepartmentSelector } from '../org.department.selector/org.department.selector';
import { CollectionMoveModalCtrl } from './collection.move.modal.ctrl';
import { CSS, Style } from './collection.move.modal.style';

addStyles(Style);

export class CollectionMoveToDepartmentModal extends ModalFormComponent {
	private ctrl: CollectionMoveModalCtrl;
	private departmentSelector: OrgDepartmentSelector;

	constructor(ctx: ModalFormComponentCtx, collections: CollectionSummaryJSONObject[]) {
		super(ctx);
		this.ctrl = new CollectionMoveModalCtrl(collections);
		this.departmentSelector = new OrgDepartmentSelector({ crossOrganization: true });
		this.addState(this.departmentSelector.inputState);
	}

	get nodes(): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.content }, [
				m('p', Translate(T.COLLECTION_MOVE_CONFIRM, { count: this.ctrl.collections.length })),
				this.departmentSelector.view(),
			]),
		]);
	}

	override submit(): Promise<void> {
		return this.ctrl.moveCollections(this.departmentSelector.selectedDepartmentId);
	}
}
